import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Container } from 'styles/sharedStyle'
import Button from 'components/Button'
import Card from 'components/Card'
import { Eyebrow, Title42 } from 'components/Typography'
import {
  OffersGridContainer,
  OffersGridHeader,
  Section,
} from './OffersGrid.style'

const OffersGrid = ({ cards, eyebrow, headline, loadMoreOffersCta }) => {
  const OFFERS_PER_PAGE = 8
  const [offersToShow, setOffersToShow] = useState(
    cards.slice(0, OFFERS_PER_PAGE)
  )
  const [currentPages, setCurrentPages] = useState(1)
  const totalPages = Math.ceil(cards.length / OFFERS_PER_PAGE)

  const loadNextOffers = () => {
    const newCurrentPages = currentPages + 1
    setCurrentPages(newCurrentPages)
    setOffersToShow(cards.slice(0, newCurrentPages * OFFERS_PER_PAGE))
  }

  // Do not display anything if there are not cards to display
  if (cards.length === 0) return null

  return (
    <OffersGridContainer as={Container} px={[0, null, 5]}>
      <OffersGridHeader>
        <Eyebrow>{eyebrow}</Eyebrow>
        <Title42>{headline}</Title42>
      </OffersGridHeader>

      {offersToShow.map((card, i) => (
        <Card {...card} key={`card_${i.toString()}`} headline={headline} />
      ))}
      {currentPages < totalPages && (
        <Section textAlign="center">
          <Button onClick={loadNextOffers} fixedSize>
            {loadMoreOffersCta}
          </Button>
        </Section>
      )}
    </OffersGridContainer>
  )
}

OffersGrid.propTypes = {
  cards: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])).isRequired,
  eyebrow: PropTypes.string.isRequired,
  headline: PropTypes.string.isRequired,
  loadMoreOffersCta: PropTypes.string.isRequired,
}

export default OffersGrid
